var map = {
	"./assamese.json": [
		64512,
		512
	],
	"./bengali.json": [
		74420,
		420
	],
	"./gujarati.json": [
		76697,
		697
	],
	"./hindi.json": [
		98370,
		370
	],
	"./kannada.json": [
		66682,
		682
	],
	"./malayalam.json": [
		41065,
		65
	],
	"./marathi.json": [
		39600,
		600
	],
	"./odia.json": [
		17583,
		583
	],
	"./punjabi.json": [
		63665,
		665
	],
	"./tamil.json": [
		71433,
		433
	],
	"./telugu.json": [
		58750,
		750
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 73162;
module.exports = webpackAsyncContext;